import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=ea7e8854&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea7e8854",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ea7e8854')) {
      api.createRecord('ea7e8854', component.options)
    } else {
      api.reload('ea7e8854', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=ea7e8854&scoped=true&", function () {
      api.rerender('ea7e8854', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2jSnPnaVI85WZ/JS/comp/Accordion.vue"
export default component.exports